import Button from '@shared/components/core/button/CoreButton';
import CardCenteredContent from '@shared/components/core/card/CardCenteredContent';
import CardStack from '@shared/components/core/card/CardStack';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

interface IOrgProjectsCardProps {
    orgId: string;
    projects?: boolean;
}

// TODO ADMIN PANEL: Update Project upgrade to link to billing page when API integration is complete.
export default function OrgProjectsCard({ orgId, projects }: IOrgProjectsCardProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <>
            {projects ? (
                <CardStack
                    name="virtualApps"
                    title={t('common:organization.projects.title')}
                    description={t('common:organization.projects.description')}>
                    <OrgLinks organizationId={orgId} variant={'orgProjects'} />
                </CardStack>
            ) : (
                <CardCenteredContent
                    name="virtualApps"
                    title={t('common:organization.projects.title')}
                    description={t('common:organization.projects.upgrade.shortDescription')}>
                    <Button href={`https://cephable.com/sdk-trial/`} startIcon="plusLight" $color="secondary">
                        {t('common:upgrade')}
                    </Button>
                </CardCenteredContent>
            )}
        </>
    );
}
